<script setup>
import {
  getActionTypeFromRating,
  getActionTypeFromScore
} from '@/Common/Enum/ActionType.js';
import getRating from '@/Common/getRating.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  score: Number,
  useRatingToCalculate: {
    type: Boolean,
    default: true
  }
});

const actionType = props.useRatingToCalculate
  ? getActionTypeFromRating(getRating(props.score))
  : getActionTypeFromScore(props.score);

const rating = {
  success: {
    class: 'text-success',
    label: t('domain_score.partials.risk_label.low')
  },
  warning: {
    class: 'text-warning',
    label: t('domain_score.partials.risk_label.moderate')
  },
  danger: {
    class: 'text-danger',
    label: t('domain_score.partials.risk_label.high')
  }
}[actionType.color];
</script>

<template>
  <h2 :class="rating.class" class="font-bold">
    {{ rating.label }}
  </h2>
</template>
